import React from 'react';
import { motion } from 'framer-motion';
interface AssistantMarkProps {
  size?: number;
  animated?: boolean;
  className?: string;
}
/**
 * On-brand monochrome assistant mark.
 * A solid white disc with a crisp black asterisk glyph — no blue, no gradients.
 * Used as the small leading mark on assistant turns and in the thinking state.
 */
export function AssistantMark({
  size = 28,
  animated = false,
  className = ''
}: AssistantMarkProps) {
  return <span className={`relative inline-flex items-center justify-center rounded-full bg-white flex-shrink-0 ${className}`} style={{
    width: size,
    height: size
  }} aria-hidden="true" data-id="element-65" data-mp="2rdel3eif42nz">
      <motion.svg width={size * 0.55} height={size * 0.55} viewBox="0 0 24 24" fill="none" animate={animated ? {
      rotate: [0, 90, 180, 270, 360]
    } : undefined} transition={animated ? {
      duration: 4,
      repeat: Infinity,
      ease: 'linear'
    } : undefined} data-id="element-66" data-mp="31cdux0ex64ck">
        <path d="M12 2.5v19M4.4 6.5l15.2 11M19.6 6.5L4.4 17.5" stroke="#0a0a0a" strokeWidth="2.4" strokeLinecap="round" data-id="element-67" data-mp="2dmt8g7jk4oyj" />
      </motion.svg>
    </span>;
}